module.exports = __webpack_public_path__ + "static/media/image_8.a7ccfe03.png";